import { toast } from 'react-toastify';
/* Input is an API resonse object.  eg. From Axios or fetch
 *
 * Handles any non-2xx responses.
 *
 * Returns true if a response was handled (false indicates the response was 200-ish)
 */
export function handleApiFailureResponses(res) {
  if (!res || !res.status) {
    // Handle cases where the response object or status is not available
    // eslint-disable-next-line no-console
    console.error('Invalid response object');
    toast.error('Network Error');
    return true; // Assuming this is an error condition
  }
  if (res.status >= 200 && res.status < 300) {
    return false;
  }

  if (res.status === 400 || res.status === 404 || res.status === 406) {
    if (res.data.message) {
      // Don't bother the user about it, but log the error to the console for developer to diagnose.
      toast.error(res.data.message);
      // eslint-disable-next-line no-console
      console.error(res.data.message);
    }
    return true;
  }

  if (res.status >= 400 && res.status < 500) {
    if (res.data.message) {
      // Load a toast with the message.
      toast.error(res.data.message);
    }

    // Redirect to logout
    setTimeout(() => {
      // Set the log_type in localStorage
      localStorage.clear();
      window.location.replace('/');
    }, 100);

    return true;
  }
  if (res.status === 500) {
    if (res.data.message) {
      // Don't bother the user about it, but log the error to the console for developer to diagnose.
      // eslint-disable-next-line no-console
      console.error(res.data.message);
      toast.error(res.data.message);
    }
    return true;
  }
  return true;
}
